import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { BlogModel } from "../context/CatalogContext";
import { useRequest } from "../context/RequestContext";
import { Box, Grid, Typography } from "@mui/material";
import { AddBox } from "@mui/icons-material";
import { maxPageWidth } from "../theme/configurationVariables";
import { format } from "date-fns";

export default function BlogContentDetailPage() {
    const { blogId } = useParams();
    const [blogDetail, setBlogDetail] = useState<BlogModel>();
    const { sendRequest } = useRequest();

    const handleClickGetBlogDetail = async () => {
        const response = await sendRequest<BlogModel>({
            path: `/api/blog/${blogId}`,
            hideLoader: true,
        });

        if (response.hasError) return;
        setBlogDetail(response.data);
    };

    useEffect(() => {
        handleClickGetBlogDetail();
    }, []);

    return (
        <Grid container spacing={4} mb={12}>
            <Grid size={{ xs: 12 }}>
                <Box p={4} display="flex" justifyContent="center">
                    {blogDetail && (
                        <Grid spacing={3} container sx={{ maxWidth: maxPageWidth }}>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="h5" fontWeight="bold" color="primary">
                                    {blogDetail.titulo}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body2" color="text.secondary" textAlign="right">
                                    {blogDetail.autor} - Publicado el {format(new Date(blogDetail.fechaPublicacion), "dd/MM/yyyy")}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                {blogDetail.contenido && <Typography textAlign="justify" dangerouslySetInnerHTML={{ __html: blogDetail.contenido.replaceAll("\n", "<br/>") }}></Typography>}
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
}
